<div class="row">
  <div class="card shadow-none rounded">
    <div class="card-body">
      <div class="col-12 col-md-12 col-xxl-12 col-xl-12">
        <div class="row">
          <div class="col-12 col-xxl-10 col-xl-10 col-md-10 col-lg-10 col-sm-8">
            <h4 class="fw-bold">Land and buildings - {{commonService.headerName}}</h4>
          </div>
          <div class="col-12 col-xxl-2 col-xl-2 col-md-2 col-lg-2 col-sm-4 text-start text-sm-end p-sm-0 pt-2">
            <button type="button" class="btn btn-outline-themecolorlight" style="padding: 7px;font-weight: 600; font-size: 14px;" tabindex="-1" (click)="TotalBack()">Close Accounts</button>
          </div>
        </div>
      </div>
      <hr />
      <form [formGroup]="landform" (ngSubmit)="save()">
        <div class="col-12 col-md-12 col-xxl-12 col-xl-12 col-lg-12  col-sm-12">
          <div class="row">
            <div class="col-12">
              <!--<h5 class="fw-bolder font-size-16">
                Land and buildings
              </h5>-->
              <p class="text-dark mb-2">Please enter notes on Land and buildings (Tangible fixed assets) in the field below.</p>
              <p class="text-dark">If you do not have any notes to make, please return to the notes menu and de-select this section.</p>
            </div>
            <div class="col-12 col-xxl-10 col-xl-12 col-md-12 col-lg-12 col-sm-12 mt-2">
              <!--Cost-->
              <div class="row">
                <div class="col-12">
                  <div class="form-group">
                    <div class="row flex-column-reverse flex-sm-row">
                      <div class="col-md-6  col-sm-6 col-12">
                        <div class="pt-2 mb-4">
                          <h6 class="fw-bolder font-size-16"> Cost</h6>
                        </div>
                      </div>
                      <div class="col-md-6  col-sm-6 col-12">
                        <div class="mb-2 text-center">
                          <h6 class="mb-0 fw-bolder">{{commonService.StartYear}}</h6>
                          <label>({{commonService.CAPeriodFrom}} to {{commonService.CAPeriodTo}})</label>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                <div class="col-12 ps-5">
                  <div class="form-group">
                    <div class="row">
                      <div class="col-md-6  col-sm-6 col-12">
                        <div class="pt-2 mb-4">
                          <label class="m-t-5 font-weight-600">At {{commonService.StartDate}}</label>
                        </div>
                      </div>
                      <div class="col-md-6  col-sm-6 col-12">
                        <div class="input-group mb-3">
                          <div class="input-group-text">
                            <span class=" theme-color font-weight-600">£</span>
                          </div>
                          <input type="text" class="form-control text-end AccountNumber" [appTooltip]="showBubbledata" appNumberdirective formControlName="PropertyPlantEquipmentGrossCost_Start" (change)="costcalculations()" maxlength="11"  />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="row">
                      <div class="col-md-6  col-sm-6 col-12">
                        <div class="pt-2 mb-4">
                          <label class="m-t-5 font-weight-600">Additions</label>
                        </div>
                      </div>
                      <div class="col-md-6  col-sm-6 col-12">
                        <div class="input-group mb-3">
                          <div class="input-group-text">
                            <span class=" theme-color font-weight-600">£</span>
                          </div>
                          <input type="text" class="form-control text-end AccountNumber" [appTooltip]="showBubbledata" appNumberdirective formControlName="TotalAdditionsIncludingFromBusinessCombinationsPropertyPlantEquipment" (change)="costcalculations()" maxlength="11" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="row">
                      <div class="col-md-6  col-sm-6 col-12">
                        <div class="pt-2 mb-4">
                          <label class="m-t-5 font-weight-600">Disposals</label>
                        </div>
                      </div>
                      <div class="col-md-6  col-sm-6 col-12">
                        <div class="input-group mb-3">
                          <div class="input-group-text">
                            <span class=" theme-color font-weight-600">£</span>
                          </div>
                          <input type="text" class="form-control text-end AccountNumber" [appTooltip]="showBubbledata" appNumberdirective formControlName="DisposalsPropertyPlantEquipment" (change)="costcalculations()" maxlength="11" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="row">
                      <div class="col-md-6  col-sm-6 col-12">
                        <div class="pt-2 mb-4">
                          <label class="m-t-5 font-weight-600">At {{commonService.EndDate}}</label>
                        </div>
                      </div>
                      <div class="col-md-6  col-sm-6 col-12">
                        <div class="input-group mb-3">
                          <div class="input-group-text">
                            <span class=" theme-color font-weight-600">£</span>
                          </div>
                          <input type="text" class="form-control text-end "  formControlName="PropertyPlantEquipmentGrossCost_End" maxlength="11"  />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!--Amortisation-->
              <div class="row">
                <div class="col-12">
                  <div class="form-group">
                    <div class="row flex-column-reverse flex-sm-row">
                      <div class="col-md-6  col-sm-6 col-12">
                        <div class="pt-2 mb-4">
                          <h6 class="fw-bolder font-size-16"> Depreciation</h6>
                        </div>
                      </div>
                      <div class="col-md-6  col-sm-6 col-12">
                        <!--<div class="mb-2 text-center">
                          <h6 class="mb-0 fw-bolder">{{commonService.StartYear}}</h6>
                          <label>({{commonService.CAPeriodFrom}} to {{commonService.CAPeriodTo}})</label>
                        </div>-->
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 ps-5">
                  <div class="form-group">
                    <div class="row">
                      <div class="col-md-6  col-sm-6 col-12">
                        <div class="pt-2 mb-4">
                          <label class="m-t-5 font-weight-600">At {{commonService.StartDate}}</label>
                        </div>
                      </div>
                      <div class="col-md-6  col-sm-6 col-12">
                        <div class="input-group mb-3">
                          <div class="input-group-text">
                            <span class=" theme-color font-weight-600">£</span>
                          </div>
                          <input type="text" class="form-control text-end AccountNumber" [appTooltip]="showBubbledata" appNumberdirective formControlName="AccumulatedDepreciationImpairmentPropertyPlantEquipment_Start" (change)="depreciation()" maxlength="11" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="row">
                      <div class="col-md-6  col-sm-6 col-12">
                        <div class="pt-2 mb-4">
                          <label class="m-t-5 font-weight-600">Charge for year</label>
                        </div>
                      </div>
                      <div class="col-md-6  col-sm-6 col-12">
                        <div class="input-group mb-3">
                          <div class="input-group-text">
                            <span class=" theme-color font-weight-600">£</span>
                          </div>
                          <input type="text" class="form-control text-end AccountNumber" [appTooltip]="showBubbledata" appNumberdirective formControlName="IncreaseDecreaseInDepreciationImpairmentPropertyPlantEquipment" (change)="depreciation()" maxlength="11" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="row">
                      <div class="col-md-6  col-sm-6 col-12">
                        <div class="pt-2 mb-4">
                          <label class="m-t-5 font-weight-600">Disposals</label>
                        </div>
                      </div>
                      <div class="col-md-6  col-sm-6 col-12">
                        <div class="input-group mb-3">
                          <div class="input-group-text">
                            <span class=" theme-color font-weight-600">£</span>
                          </div>
                          <input type="text" class="form-control text-end AccountNumber" [appTooltip]="showBubbledata" appNumberdirective formControlName="DisposalsDecreaseInDepreciationImpairmentPropertyPlantEquipment" (change)="depreciation()" maxlength="11" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="row">
                      <div class="col-md-6  col-sm-6 col-12">
                        <div class="pt-2 mb-4">
                          <label class="m-t-5 font-weight-600">At {{commonService.EndDate}}</label>
                        </div>
                      </div>
                      <div class="col-md-6  col-sm-6 col-12">
                        <div class="input-group mb-3">
                          <div class="input-group-text">
                            <span class=" theme-color font-weight-600">£</span>
                          </div>
                          <input type="text" class="form-control text-end AccountNumber" appNumberdirective formControlName="AccumulatedDepreciationImpairmentPropertyPlantEquipment_End" maxlength="11"  />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              
              <!--Net book value-->
              <div class="row">
                <div class="col-12">
                  <div class="form-group">
                    <div class="row flex-column-reverse flex-sm-row">
                      <div class="col-md-6  col-sm-6 col-12">
                        <div class="pt-2 mb-4">
                          <h6 class="fw-bolder font-size-16"> Net book value</h6>
                          <!--<label>Net book value</label>-->
                        </div>
                      </div>
                      <div class="col-md-6  col-sm-6 col-12">
                        <!--<div class="mb-2 text-center">
                          <h6 class="mb-0 fw-bolder">{{commonService.StartYear}}</h6>
                          <label>({{commonService.CAPeriodFrom}} to {{commonService.CAPeriodTo}})</label>
                        </div>-->
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 ps-5">
                  <div class="form-group">
                    <div class="row">
                      <div class="col-md-6  col-sm-6 col-12">
                        <div class="pt-2 mb-4">
                          <label class="m-t-5 font-weight-600">At {{commonService.EndDate}}</label>
                        </div>
                      </div>
                      <div class="col-md-6  col-sm-6 col-12">
                        <div class="input-group mb-3">
                          <div class="input-group-text">
                            <span class=" theme-color font-weight-600">£</span>
                          </div>
                          <input type="text" class="form-control text-end  AccountNumber" appNumberdirective [appTooltip]="showBubbledata" formControlName="PropertyPlantEquipment_Start" maxlength="11"  />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="row">
                      <div class="col-md-6  col-sm-6 col-12" *ngIf="commonService.showControl==true">
                        <div class="pt-2 mb-4">
                          <label class="m-t-5 font-weight-600">At {{commonService.LastyearEndDate}}</label>
                        </div>
                      </div>
                      <div class="col-md-6  col-sm-6 col-12" *ngIf="commonService.showControl==true">
                        <div class="input-group mb-3">
                          <div class="input-group-text">
                            <span class=" theme-color font-weight-600">£</span>
                          </div>
                          <input type="text" class="form-control text-end  AccountNumber" appNumberdirective [appTooltip]="showBubbledata" formControlName="PropertyPlantEquipment_End" maxlength="11"  />
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
             
            

              <div class="row mb-3">
 
                <div class="col-12 col-xxl-12 col-xl-12 col-md-12 col-lg-12 col-sm-12">

                  <label class="pb-2">
                    Please enter any additional information in the field below.
                  </label>
                  <div class="mb-3">
                    <textarea class="form-control allowSpecialChars" [appTooltip]="showBubbledata" appNumberdirective rows="6" required formControlName="PropertyPlantEquipmentFreeøtextComment" maxlength="4000"></textarea>
                  </div>
                </div>

              </div>

            </div>
            <div class="col-12 col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 text-end mt-4">
              <button type="button" class="btn btn-outline-back p-1 ps-3 pe-3 me-2" (click)="back()">Back</button>
              <button type="button" class="btn themedefault p-1 ps-3 pe-3 ms-1 me-0" (click)="save()">Next</button>
            </div>
          </div>
        </div>
      </form>
    </div>
    </div>
  </div>
